import Vue from "vue";
import VueRouter from "vue-router";
import * as CONFIG from "./config.js";

Vue.use(VueRouter);

const requireAppRoutes = require.context(".", true, /routes.js$/);

function mergeAppRoutes() {
  //Merges all routes.js files in the project!
  let routes = [];
  requireAppRoutes.keys().forEach((fileName) => {
    const foundRoutes = requireAppRoutes(fileName);
    routes = routes.concat(foundRoutes.default);
  });
  return routes;
}

const routes = mergeAppRoutes();

const router = new VueRouter({
  base: CONFIG.BaseURL,
  routes,
});

// Suppress NavigationDuplicated errors globally
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

export default router;

export { routes };
